
import { defineComponent } from 'vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VModal from '@/components/vendor/modal/VModal.vue';
import ModalHeader from '@/components/vendor/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/modal/ModalBody.vue';
import ModalFooter from '@/components/vendor/modal/ModalFooter.vue';
import Professional from '@/api/objects/Professional';
import { mapState } from 'vuex';
import api from '@/api';

export default defineComponent({
  name: 'TheAdminProfessionalDestroy',
  components: {
    ModalFooter,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
    VButton,
  },
  emits: ['closed', 'professionalDestroyed'],
  props: {
    professional: {
      type: Professional,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['authUser']),
    ...mapState('app', ['formsSettings']),
  },
  methods: {
    async destroyProfessional() {
      try {
        // TODO: Send the request to update that video
        await api.admin.professional.delete(this.professional.id);

        await this.$modal.info({
          title: this.$t('Profesional eliminado'),
          text: this.$t('Se ha eliminado el profesional con éxito.'),
        });

        this.$emit('professionalDestroyed');
        this.closeModal();
        await this.$router.push({ name: 'admin.professional.index' });
      } catch (e) {
        // TODO: Handle possible exceptions
        this.$toast.error(e.response?.data?.message);
      }
    },
    closeModal() {
      this.$emit('closed');
    },
  },
});
